import * as React from 'react';
import * as styles from './styles.css';
import { clsx as cn } from 'clsx';

import { UIHeading3, UIHeading4, UIText1 } from '@cian/ui-kit';
import { ConditionalWrapper } from '@cian/conditional-component';

interface IListCardProps {
  address: string;
  title: string;
  isActive: boolean;
  onClick(): void;
  isDesktop: boolean;
}

export const ListCard: React.FC<IListCardProps> = ({ address, title, isActive, isDesktop, onClick }) => {
  return (
    <div
      data-testid="ListCard"
      className={cn(styles['container'], isActive && styles['container-active'])}
      onClick={onClick}
    >
      <div className={styles['title']}>
        <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading4} ElseComponent={UIHeading3}>
          {title}
        </ConditionalWrapper>
      </div>
      <div className={styles['address']}>
        <UIText1 as="span" color="gray60_100">
          {address}
        </UIText1>
      </div>
    </div>
  );
};

ListCard.displayName = 'ListCard';
